export class NotificationSystem {
  private container: HTMLElement | null = null;
  private readonly MAX_VISIBLE = 5;
  private readonly DEFAULT_DURATION = 4000;

  init(containerId: string): void {
    this.container = document.getElementById(containerId);
  }

  show(text: string, duration: number = this.DEFAULT_DURATION): void {
    if (!this.container) return;

    while (this.container.children.length >= this.MAX_VISIBLE) {
      this.container.firstChild?.remove();
    }

    const el = document.createElement('div');
    el.className = 'notification';
    el.textContent = text;
    this.container.appendChild(el);

    setTimeout(() => {
      if (el.parentNode) el.remove();
    }, duration);
  }

  showAchievement(name: string): void {
    this.show(`🏆 Achievement: ${name}`, 5000);
  }

  showBuff(name: string): void {
    this.show(`✨ ${name}`, 3000);
  }

  clear(): void {
    if (this.container) {
      while (this.container.firstChild) {
        this.container.firstChild.remove();
      }
    }
  }
}
